/* eslint-disable no-param-reassign */

function debounce(fn, delay) {
  let timeoutID = null;
  return function timer(...args) {
    clearTimeout(timeoutID);
    const that = this;
    timeoutID = setTimeout(() => {
      fn.apply(that, args);
    }, delay);
  };
}

export default {

  install(Vue) {
    Vue.debounce = debounce;
    Vue.prototype.$debounce = debounce;
  },

};
